import { Children, isValidElement } from 'react';

import { Box, BoxProps } from '../Box';

export interface StackProps extends BoxProps {
  space?: BoxProps['paddingBottom'];
  inline?: boolean;
  props?: BoxProps;
}

export const Stack = ({ children, space, inline, props, ...rest }: StackProps) => {
  return (
    <Box display="flex" flexDirection={inline ? 'row' : 'column'} {...rest} data="tags">
      {Children.toArray(children)
        .filter(isValidElement)
        .map((child, index) => (
          <Box
            key={index}
            {...(inline
              ? { marginLeft: index !== 0 ? space : undefined }
              : { marginTop: index !== 0 ? space : undefined })}
            {...props}
          >
            {child}
          </Box>
        ))}
    </Box>
  );
};
